import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderBtn,
  SliderCount,
  SliderDots,
  SliderItem,
  SliderProgress,
} from '@studiometa/ui';
import SliderDrag from './SliderDrag';
// import SliderWheel from './SliderWheel';

/**
 * Slider class.
 */
export default class Slider extends withBreakpointObserver(SliderCore) {
  static config = {
    components: {
      SliderBtn,
      SliderCount,
      SliderDots,
      SliderDrag,
      SliderItem,
      SliderProgress,
      // SliderWheel,
    },
  };
}
